interface Episode {
  title: string;
  audioUrl: string;
}

const RSS_URL = 'https://anchor.fm/s/e80cf13c/podcast/rss';

const parseXMLFeed = (xmlText: string): Episode => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
  
  // Verifica se houve erro no parsing
  const parserError = xmlDoc.querySelector('parsererror');
  if (parserError) {
    throw new Error('Erro ao fazer parse do XML');
  }
  
  // Pega o primeiro item (episódio mais recente)
  const item = xmlDoc.querySelector('item');
  
  if (!item) {
    throw new Error('Nenhum episódio encontrado');
  }
  
  const title = item.querySelector('title')?.textContent || 'Título não disponível';
  const audioUrl = item.querySelector('enclosure')?.getAttribute('url') || '';
  
  if (!audioUrl) {
    throw new Error('URL do áudio não encontrada');
  }
  
  return {
    title: title.trim(),
    audioUrl
  };
};

export const getLatestEpisode = async (): Promise<Episode> => {
  try {
    const response = await fetch(RSS_URL, {
      headers: {
        'Accept': 'application/xml, text/xml, */*'
      },
      cache: 'no-cache'
    });

    if (!response.ok) {
      throw new Error(`Erro HTTP: ${response.status}`);
    }

    const xmlText = await response.text();
    return parseXMLFeed(xmlText);
  } catch (error) {
    console.error('Erro ao buscar feed RSS:', error);
    throw new Error('Falha ao obter o episódio mais recente');
  }
}; 